import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import {combineReducers} from 'redux';
import userReducer from './user-reducer';
import articlesReducer from './article-reducer';
import configReducer from './config-reducer';
import usersReducer from './users-reducers';

const objReducer = {
  user: userReducer,
  articles: articlesReducer,
  configReducer: configReducer,
  usersReducer: usersReducer
};
const mainReducer = combineReducers(objReducer);

export const store = configureStore({
  reducer: mainReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
  ],
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const getCurrentToken = () => store.getState().user.token;
